import React, { Fragment } from 'react';
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { queryStrCategory, queryStrWinner } from './Constants';

//styles
import './css/Custom.css';

//common
import Header from './components/common/Header';

//components
import Home from './components/home/Home';
import Winner from './components/player/Winner';

const App = () => {

    return (
        <Fragment>
            <Header />
            <Router>
                <HandleViews />                    
            </Router>                    
        </Fragment>
    )
}

export default App;

const GetQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const HandleViews = () => {

    const { search } = useLocation();    
    const query = GetQuery();
    const slugCategory = query.get(queryStrCategory);
    const slugWinner = query.get(queryStrWinner);

    if ((search.includes(queryStrCategory) && slugCategory !== null) && (search.includes(slugWinner) && slugWinner !== null)){
        return <Winner slugCategory={slugCategory} slugWinner={slugWinner} />  
    } else {
        return <Home />;
    }
}
